import { IonLabel } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { FormGroup, Input } from "reactstrap";
import { Rider } from "../../models";
import RequiredInputIndicator from "../Forms/RequiredInputIndicator";

interface _Props {
    rider?: Rider | null;
    isRequired?: boolean;
    onChange: (isProfessional?: (boolean | null)) => void;
}

const RiderSelectStatus: React.FC<_Props> = ({ rider, isRequired, onChange }) => {
    const [status, setStatus] = useState<string>("-");

    useEffect(() => {
        if (rider) {
            if (rider.isProfessional === true) setStatus("Professional");
            else if (rider.isProfessional === false) setStatus("Non-Professional (Amateur / Junior)");
            else setStatus("-");
        } else {
            setStatus("-");
        }
    }, [rider?.id, rider?.isProfessional]);

    return (
        <>
            <FormGroup>
                <IonLabel position="stacked" className="description pl-3">
                    Rider Status
                    {isRequired && <RequiredInputIndicator />}
                </IonLabel>
                <Input
                    name="isProfessionalInput"
                    type="select"
                    value={status}
                    onChange={(e) => {
                        setStatus(e.target.value);
                        onChange(e.target.value === "-" ? null : (e.target.value === "Professional"));
                    }}>
                    <option>-</option>
                    <option>Non-Professional (Amateur / Junior)</option>
                    <option>Professional</option>
                </Input>
            </FormGroup>
        </>
    );
};

export default RiderSelectStatus;
